/* eslint-disable consistent-return */
import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';

/**
 * A source object for iTasker.
 *
 * @typedef {object} Source
 * @property {string} [_id] - The source id.
 * @property {string[]} [attributes] - The names of the attributes to be selected.
 * @property {string} [connectorId] - The associated connector id for this source.
 * @property {string} [createdAt] - The date when it was created.
 * @property {string} [deleted] - Indicates whether it is in the trash or not.
 * @property {string} [layerName] - The name of the layer or table to be selected.
 * @property {string} [name] - The name for the source.
 * @property {string} [owner] - The owner id.
 * @property {string} [updatedAt] - The date when it was last updated.
 */

const Sources = new Mongo.Collection('Sources');

Sources.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

Sources.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});

Sources.schema = new SimpleSchema({
  attributes: {
    type: Array,
    label: 'The attributes of the source',
    optional: true
  },
  'attributes.$': {
    type: String,
    label: 'An attibute of the source',
    optional: true
  },
  connectorId: {
    type: String,
    label: 'The Id of the connection for this source',
    optional: true
  },
  createdAt: {
    type: String,
    label: 'The date this source was created in the database',
    optional: true,
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    }
  },
  deleted: {
    type: String,
    label: 'The date the source was deleted',
    optional: true,
    autoValue() {
      if (this.isInsert) return 'no';
    }
  },
  layerName: {
    type: String,
    label: 'The name of the table view or the layer for the source',
    optional: true
  },
  layerNameSource: {
    type: String,
    label: 'The name of the table view or the layer for the source with two dots',
    optional: true
  },
  name: {
    type: String,
    label: 'A name to identify the source',
    optional: true
  },
  owner: {
    type: String,
    label: 'The ID of the user this source belongs to',
    optional: true
  },
  updatedAt: {
    type: String,
    label: 'The date this source was last updated',
    optional: true,
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    }
  }
});

Sources.attachSchema(Sources.schema);

export default Sources;
